











































































































import BaseFilter from "@/components/Filter/BaseFilter";
import { DetailIncomingFilterParams } from "@/store/call/statistic/types";
import { Component, PropSync, Watch } from "vue-property-decorator";
import { FastDateDetailWings, DatePickerWings, SelectWings, NumberWings } from "wings-ui-components";
import { beginningOfCurrentDay, currentDateEnd, dateFilter } from "@/utils/date-util";
import { notifyError, notifyWarning } from "@/utils/notify-helper";
import { Action, Getter } from "vuex-class";
import { MsgTransports } from '@/store/types';
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({
  components: {DatePickerWings, FastDateDetailWings, SelectWings, NumberWings},
  filters: {dateFilter}
})
export default class CallDetailIncomingFilter extends BaseFilter<DetailIncomingFilterParams> {
  @PropSync('show') is_show!: boolean;
  @PropSync("filterClone") propFilterClone!: any;
  @PropSync("runFilter") propRunFilter!: any;

  @Getter("callMessagesStatusList") statusList: any;

  @Action("getCallStatisticDetailIncoming") actionGetItems: any;
  @Action("exportCallStatisticDetailIncoming") actionExport: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("actionLog") actionLog: any;

  defaultFilter(): DetailIncomingFilterParams {
    return new DetailIncomingFilterParams(beginningOfCurrentDay(), currentDateEnd());
  }

  params: object = {transport: MsgTransports.CALL};
  partnersList: any = [];
  filterKeys: object = {
    "originator": "addresser",
    "service_number" : "service_no"
  }

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners({...this.params, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async created() {
    if (this.filter.partner) this.partnersList = await this.actionGetPartners({name: this.filter.partner});
  }

  async onFilteredAction() {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: 'success',
        object_type: "Detail statistics of incoming messages",
        addititional_info: getTranslatedParams(this.filter, this.filterKeys)
      };
      const resp = await this.actionGetItems(this.filter);
      await this.actionLog(this.logObject);
      if (resp.status == 204) {
        notifyWarning()
      }
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: 'failed'});
      notifyError(err);
    }
  }

  // Override
  async doActionExport(): Promise<any> {
    return await this.actionExport(this.sendFilter);
  }

  @Watch('filter', { immediate: true, deep: true })
  onFilterChange(val: DetailIncomingFilterParams) {
    this.propFilterClone = val;
  }

  @Watch('runFilter', { immediate: true })
  onRunFilterChange(val: boolean) {
    if (val) {
      this.filtered();
      this.propRunFilter = false;
    }
  }
}
